import { render, staticRenderFns } from "./SpeakerCard.vue?vue&type=template&id=65323e62&scoped=true&"
import script from "./SpeakerCard.vue?vue&type=script&lang=js&"
export * from "./SpeakerCard.vue?vue&type=script&lang=js&"
import style0 from "./SpeakerCard.vue?vue&type=style&index=0&id=65323e62&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65323e62",
  null
  
)

export default component.exports